import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";

/*
 * Menu Management Services
 * !== 메뉴 관리 서비스 ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */

export const BASE = {
    path: `${ptlEnvs.base}/ptl/menu`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/ptl/menu/menu-mgmt`,
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli1001001q: `${BASE.path}/ptli1001001q`, // Select. Menu List !== 메뉴 목록 ==!
    ptli1001002s: `${BASE.path}/ptli1001002s`, // Create. Menu Info !== 메뉴 정보 생성 ==!
    ptli1001003s: `${BASE.path}/ptli1001003s`, // Save. Menu Info !== 메뉴 정보 저장 ==!
};

export const PGEUIDS = {
    ptli1001001q: "ptli1001001q",
    ptli1001002s: "ptli1001002s",
    ptli1001003s: "ptli1001003s",
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // View Menu List !== 메뉴 목록 조회 ==!
    getMenuList: (data: any) => api.get(`${BASE.api}`, { params: comnUtils.toGetParams(data) }),
    // View Menu Info !== 메뉴 정보 조회 ==!
    getMenuInfo: (menuId: any) => api.get(`${BASE.api}/${menuId}`),
    // Select. Check Duplicate Menu ID !== 메뉴ID 중복체크 조회 ==!
    getChkMenuId: (data: any) => api.get(`${BASE.api}/menuId`, { params: comnUtils.toGetParams(data) }),
    // Create a menu list !== 메뉴 목록 생성 ==!
    createMenuMgmt: (data: any) => api.post(`${BASE.api}`, { ...data }),
    // Modify the menu list !== 메뉴 목록 수정 ==!
    updateMenuMgmt: (data: any) => api.put(`${BASE.api}/${data["menuId"]}`, { ...data }),
    // Delete a menu list !== 메뉴 목록 삭제 ==!
    deleteMenuMgmt: (data: any) => api.delete(`${BASE.api}/${data["menuId"]}`),
};

export const SF_MENU_MGMT_SRCH: TFormSchema = {
    id: "form_menuMgmtSrch",
    schema: {
        bsopClsfCd: {
            required: true,
            type: "select",
            label: "L_BSOP_CLSF_CD",
            area: "comnCd",
            comnCd: "COM0024",
            excludes: ["COM"],
        },
        ptlTpCd: {
            required: true,
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "COM0052",
            excludes: ["B"],
        },
        menuPath: { type: "text", label: "L_MENU_PATH", edit: false },
        menuId: { type: "text" },
    },
};

export const SF_MENU_MGMT: TFormSchema = {
    id: "form_menuMgmt",
    schema: {
        menuNm: { type: "text", label: "L_MENU_NM", edit: false },
        menuPath: { type: "text", label: "L_MENU_PATH", edit: false },
        menuOrd: { type: "number", label: "L_MENU_ORD", maxLength: 4 },
        uprMenuId: { type: "text", label: "L_UPR_MENU_ID", edit: false },
        uprMenuNm: { type: "text", label: "L_UPR_MENU_NM", edit: false },
        menuId: {
            required: true,
            type: "text",
            label: "L_MENU_ID",
            edit: false,
            placeholder: "menu_ptli0001",
            pattern: { value: /menu_[a-z]{3}[i|e|o][0-9]{4}/, message: "msg.ptl.00695" },
        },
        bsopClsfCd: {
            required: true,
            type: "select",
            label: "L_BSOP_CLSF_CD",
            area: "comnCd",
            comnCd: "COM0024",
            excludes: ["COM"],
        },
        ptlTpCd: {
            required: true,
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "COM0052",
            excludes: ["B"],
        },
        menuNmKO: { required: true, type: "text", label: "L_MENU_NM_KO" },
        menuNmEN: { required: true, type: "text", label: "L_MENU_NM_EN" },
        menuNmTZ: { required: true, type: "text", label: "L_MENU_NM_TZ" },
        menuPrmtValue: { type: "text", label: "L_MENU_PRMT_VALUE" },
        menuLeafYn: { type: "text" },
    },
};

export const SG_MENU_LANG_LIST: TGridSchema = {
    id: "grid_menuLangList",
    options: { checkbox: true, height: 123 },
    head: [
        { cells: [{ header: "L_LANG_CD", binding: "langCd", width: 100 }] },
        { cells: [{ header: "L_MENU_NM", binding: "menuNm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "langCd", required: true, edit: true }] },
        { cells: [{ binding: "menuNm", required: true, edit: true, align: "left" }] },
    ],
};
